import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import BeaconDropdownMetricColumnChart from 'src/components/BeaconV2Components/BeaconMetricColumnChart/BeaconDropdownMetricColumnChart';
import TopEntityChartV2Loading from 'src/components/BeaconV2Components/TopEntityChartV2/TopEntityChartV2Loading';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import ProductsWithRetailSalesSplineChart from 'src/components/BeaconV2Components/ExperimentalLayout/Sales/ProductsWithRetailSalesSplineChart';
import RetailSalesProductsList from 'src/components/BeaconV2Components/ExperimentalLayout/Summary/Sales/RetailSales/RetailSalesProductsList';
import { BeaconSplineChartWithPromotionsWrapper } from 'src/components/BeaconV2Components/ExperimentalLayout/Prices/Promotions/BeaconSplineChartWithPromotions';
import { ChartContextProvider } from 'src/utils/chartContext/ChartContextGroupContext';
import { CHART_CONTEXT_GROUPS, CHART_NAMES } from 'src/utils/chartContext/chartContextRegistry';

const RetailSalesPage = () => {
  const entityType = useMainEntityType();

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_RETAIL_SALES.name}
          chartName={CHART_NAMES.BEACON_RETAIL_SALES_SPLINE}
        >
          <BeaconSplineChartWithPromotionsWrapper indexName="sales" fieldName="retailSales" />
        </ChartContextProvider>
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_WHOLESALE_SALES.name}
          chartName={CHART_NAMES.BEACON_WHOLESALE_SALES_SPLINE}
        >
          <BeaconSplineChartWithPromotionsWrapper indexName="sales" fieldName="wholesaleSales" />
        </ChartContextProvider>
        <ChartContextProvider
          group={CHART_CONTEXT_GROUPS.BEACON_RETAIL_SALES_BY_ENTITY.name}
          chartName={CHART_NAMES.BEACON_RETAIL_SALES_BY_ENTITY_COLUMN}
        >
          <BeaconDropdownMetricColumnChart
            beaconChartWithLegendPropsBuilder={(props) => ({
              ...props,
              loadingComponent: <TopEntityChartV2Loading />
            })}
            indexName="sales"
            fieldName="retailSales"
            dropdownOptions={[
              {
                id: 'subCategoryId',
                label: 'Subcategory'
              },
              {
                id: 'categoryId',
                label: 'Category'
              },
              {
                id: 'brandId',
                label: 'Brand'
              }
            ].filter((option) => !option.id.toLowerCase().startsWith(entityType))}
            titlePrefix="Retail Sales by"
          />
        </ChartContextProvider>
        {entityType !== 'product' && (
          <ChartContextProvider
            group={CHART_CONTEXT_GROUPS.BEACON_PRODUCTS_WITH_RETAIL_SALES.name}
            chartName={CHART_NAMES.BEACON_PRODUCTS_WITH_RETAIL_SALES_SPLINE}
          >
            <ProductsWithRetailSalesSplineChart />
          </ChartContextProvider>
        )}
        <RetailSalesProductsList />
      </Flex>
    </BasePageContainer>
  );
};

export default RetailSalesPage;
